<script>
import Main from './main.vue';

export default Main.extend({
  methods: {
    getData() {
      return new Promise((res) => {
        // Seed data
        const output = [
          {
            name: 'Source language(s)',
            data: [{
              x: 0,
              y: 1,
              data: this.chartData.SourceLanguageCount,
            }],
          },
          {
            name: 'Target language(s)',
            data: [{
              x: 1,
              y: 1,
              data: this.chartData.TargetLanguageCount,
            }],
          },
          {
            name: 'Language pairs',
            data: [{
              x: 2,
              y: 1,
              data: this.chartData.LanguageCombinationsCount,
            }],
          },
        ];
        res(output);
      });
    },
  },
});
</script>
